import React from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export default function ReplyPreview({ message, onCancel }) {
    const { theme } = useTheme();

    if (!message) return null;

    return (
        <div className={`flex items-center gap-2 px-4 py-2 border-t ${
            theme === 'dark' ? 'bg-gray-750 border-gray-600' : 'bg-gray-50 border-gray-200'
        }`}>
            <div className={`w-1 h-8 rounded-full flex-shrink-0 ${
                theme === 'dark' ? 'bg-blue-400' : 'bg-blue-500'
            }`} />
            <div className="flex-1 min-w-0">
                <p className={`text-xs font-unna font-medium ${
                    theme === 'dark' ? 'text-blue-400' : 'text-blue-600'
                }`}>
                    Replying to {message.user?.username}
                </p>
                <p className={`text-xs font-rasa truncate ${
                    theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                }`}>
                    {message.content}
                </p>
            </div>
            <button
                onClick={onCancel}
                className={`p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-600 ${
                    theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                }`}
            >
                <X size={14} />
            </button>
        </div>
    );
}
